// Match date/time from the backend are Italian wall-clock (Europe/Rome).
// Convert to an absolute Date independent of the device time zone (DST-aware).
const romeOffsetMs = (utcMs) => {
  const p = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Rome', hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    }).formatToParts(new Date(utcMs)).map(x => [x.type, x.value]),
  );
  return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - utcMs;
};

export const italyToDate = (matchDate, matchTime) => {
  const dm = /^(\d{4})-(\d{2})-(\d{2})$/.exec(matchDate || '');
  const tm = /^(\d{1,2}):(\d{2})/.exec(matchTime || '');
  if (!dm || !tm) return null;
  const wall = Date.UTC(+dm[1], +dm[2] - 1, +dm[3], +tm[1], +tm[2]);
  let utc = wall - romeOffsetMs(wall);
  utc = wall - romeOffsetMs(utc);
  return new Date(utc);
};
